import React, { useState } from "react";
import "../style.css";
import play from "../../../assets/images/play_circle.svg";

interface Image {
  image: string;
}

interface GalleryThumbnailListProps {
  images: Image[];
  updateSelectedImage: (img: string) => void;
  video: string | null;
  setVideoSelected: (selected: boolean) => void;
  defaultThumbnail: number;
 }

const Gallery__ThumbnailList: React.FC<GalleryThumbnailListProps> = ({
  images,
  updateSelectedImage,
  video,
  setVideoSelected,
  defaultThumbnail,
}) => {
  const [clickedImage, setClickedImage] = useState<number>(defaultThumbnail);

  const handleSelectedThumbnail = (img: string, index: number) => {
    updateSelectedImage(img);
    setClickedImage(index);
    setVideoSelected(index === 0 && video != null);
  };

  return (
    <div className="flex max-w-full overflow-x-auto tw-pb-4 ln-overflow--hover">
      {images.map((image, index) => (
        <button
          key={index}
          onClick={() => handleSelectedThumbnail(image.image, index)}
          className={`ln-thumbnail ${index === clickedImage ? "ln-thumbnail--active" : ""}`}
          data-track={`thumbnail-button-${index}`}
        >
          {index === 0 && video != null && (
            <img src={play} alt="thumbnail" className="ln-position-center" />
          )}
          <img src={image.image} alt="play-button" />
        </button>
      ))}
    </div>
  );
};

export default Gallery__ThumbnailList;
